module.exports = __webpack_public_path__ + "img/10.aff57078.jpg";